import { SocketService } from '@events/chat/socket.service';
import { Injectable } from '@angular/core';
import { UserHelperService } from '@helpers/user-helper.service';
import { UserAttributesI } from '@interfaces/user.interface';
import { Socket } from '@node_modules/socket.io-client/build/esm';

@Injectable({
  providedIn: 'root',
})
export class CustomerSocketService {
  socket!: Socket;
  customerId!: string;
  private inited: boolean = false;
  constructor(private socketService: SocketService, private userHelper: UserHelperService) {}
  public init() {
    if (this.inited) {
      return;
    }
    this.socket = this.socketService.init();
    if (this.socket) {
      this.leave();
      this.join();
      this.inited = true;
    }
  }

  private join() {
    this.socket.emit('join-rooms', [this.customerId]);
  }
  private leave() {
    this.socket.emit('leave-rooms', [this.customerId]);
  }
}
